import i18n from "i18n";

export const getEventsConfig = (city) => {
  const eventsConfig = {
    wroclaw: {
      birthday: [
        {
          name: "PIXEL",
          priceMonToThr: "549 PLN",
          priceFriToSun: "779 PLN",
          features: [
            { value: 1, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: false, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 6, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "L",
          priceMonToThr: "899 PLN",
          priceFriToSun: "1199 PLN",
          features: [
            { value: 2, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 12, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XL",
          priceMonToThr: "1399 PLN",
          priceFriToSun: "1799 PLN",
          features: [
            { value: "2 + Arena", label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 22, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XXL",
          priceMonToThr: "2299 PLN",
          priceFriToSun: "2899 PLN",
          features: [
            { value: "4 + Arena", label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: true, label: i18n.t("birthdayPage.voucher") },
            { value: 40, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
      ],
      additional: {
        leftColumn: [
          i18n.t("birthdayPage.trainer", { price: 199 }),
          i18n.t("birthdayPage.additionalGuest", { price: 79 }),
          i18n.t("birthdayPage.additionalBirthdayBoy", { price: 99 }),
        ],
        rightColumn: [
          i18n.t("birthdayPage.sweetSet", { price: 49 }),
          i18n.t("birthdayPage.saltySet", { price: 49 }),
          i18n.t("birthdayPage.socks", { price: 10 }),
          i18n.t("birthdayPage.polishLodyPortion", { price: 10 }),
        ],
      },
      cakes: [
        i18n.t("birthdayPage.bigIceCreamCake", {
          name: "Słodziak White",
          price: 229,
          link: "https://polishlody.com/torty/slodziak-white-2/",
        }),
        i18n.t("birthdayPage.smallIceCreamCake", {
          name: "Igloo Klasyk",
          price: 119,
          link: "https://polishlody.com/torty/igloo-klasyk/",
        }),
        i18n.t("birthdayPage.smallIceCreamCake", {
          name: "Igloo Kinder",
          price: 139,
          link: "https://polishlody.com/torty/igloo-kinder/",
        }),
      ],
    },
    katowice: {
      birthday: [
        {
          name: "PIXEL",
          priceMonToThr: "549 PLN",
          priceFriToSun: "719 PLN",
          features: [
            { value: 1, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: false, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 6, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "L",
          priceMonToThr: "899 PLN",
          priceFriToSun: "1099 PLN",
          features: [
            { value: 2, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 12, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XL",
          priceMonToThr: "1349 PLN",
          priceFriToSun: "1549 PLN",
          features: [
            { value: 3, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 18, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XXL",
          priceMonToThr: "1799 PLN",
          priceFriToSun: "2099 PLN",
          features: [
            { value: 4, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: true, label: i18n.t("birthdayPage.voucher") },
            { value: 24, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
      ],
      additional: {
        leftColumn: [
          i18n.t("birthdayPage.trainer", { price: 199 }),
          i18n.t("birthdayPage.additionalGuest", { price: 79 }),
          i18n.t("birthdayPage.additionalBirthdayBoy", { price: 99 }),
        ],
        rightColumn: [
          i18n.t("birthdayPage.sweetSet", { price: 49 }),
          i18n.t("birthdayPage.saltySet", { price: 49 }),
          i18n.t("birthdayPage.socks", { price: 10 }),
        ],
      },
      cakes: [
        i18n.t("birthdayPage.bigIceCreamCake", {
          name: "Słodziak White",
          price: 229,
          link: "https://polishlody.com/torty/slodziak-white-2/",
        }),
        i18n.t("birthdayPage.smallIceCreamCake", {
          name: "Igloo Klasyk",
          price: 119,
          link: "https://polishlody.com/torty/igloo-klasyk/",
        }),
        i18n.t("birthdayPage.smallIceCreamCake", {
          name: "Igloo Kinder",
          price: 139,
          link: "https://polishlody.com/torty/igloo-kinder/",
        }),
      ],
    },
    gdansk: {
      birthday: [
        {
          name: "PIXEL",
          priceMonToThr: "549 PLN",
          priceFriToSun: "719 PLN",
          features: [
            { value: 1, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: false, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 6, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "L",
          priceMonToThr: "899 PLN",
          priceFriToSun: "1099 PLN",
          features: [
            { value: 2, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 12, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XL",
          priceMonToThr: "1349 PLN",
          priceFriToSun: "1549 PLN",
          features: [
            { value: 3, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 18, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XXL",
          priceMonToThr: "1799 PLN",
          priceFriToSun: "2099 PLN",
          features: [
            { value: 4, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: true, label: i18n.t("birthdayPage.voucher") },
            { value: 24, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
      ],
      additional: {
        leftColumn: [
          i18n.t("birthdayPage.trainer", { price: 199 }),
          i18n.t("birthdayPage.additionalGuest", { price: 79 }),
          i18n.t("birthdayPage.additionalBirthdayBoy", { price: 99 }),
        ],
        rightColumn: [
          i18n.t("birthdayPage.sweetSet", { price: 49 }),
          i18n.t("birthdayPage.saltySet", { price: 49 }),
          i18n.t("birthdayPage.socks", { price: 10 }),
        ],
      },
      cakes: [
        i18n.t("birthdayPage.bigIceCreamCake", {
          name: "Słodziak White",
          price: 229,
          link: "https://polishlody.com/torty/slodziak-white-2/",
        }),
        i18n.t("birthdayPage.smallIceCreamCake", {
          name: "Igloo Klasyk",
          price: 119,
          link: "https://polishlody.com/torty/igloo-klasyk/",
        }),
        i18n.t("birthdayPage.smallIceCreamCake", {
          name: "Igloo Kinder",
          price: 139,
          link: "https://polishlody.com/torty/igloo-kinder/",
        }),
      ],
    },
    poznan: {
      birthday: [
        {
          name: "PIXEL",
          priceMonToThr: "549 PLN",
          priceFriToSun: "719 PLN",
          features: [
            { value: 1, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: false, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 6, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "L",
          priceMonToThr: "899 PLN",
          priceFriToSun: "1099 PLN",
          features: [
            { value: 2, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: false, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 12, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XL",
          priceMonToThr: "1349 PLN",
          priceFriToSun: "1549 PLN",
          features: [
            { value: 3, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: false, label: i18n.t("birthdayPage.voucher") },
            { value: 18, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
        {
          name: "XXL",
          priceMonToThr: "1799 PLN",
          priceFriToSun: "2099 PLN",
          features: [
            { value: 4, label: i18n.t("birthdayPage.matNumber") },
            { value: true, label: i18n.t("birthdayPage.bottleOfWater") },
            { value: true, label: i18n.t("birthdayPage.snackSet") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksChild") },
            { value: true, label: i18n.t("birthdayPage.printedInvitations") },
            { value: true, label: i18n.t("birthdayPage.tableware") },
            { value: true, label: i18n.t("birthdayPage.certificate") },
            { value: true, label: i18n.t("birthdayPage.bottleOfJuice") },
            { value: true, label: i18n.t("birthdayPage.nonSlipSocksGuest") },
            { value: true, label: i18n.t("birthdayPage.voucher") },
            { value: 24, label: i18n.t("birthdayPage.numberOfPlayers") },
          ],
        },
      ],
      additional: {
        leftColumn: [
          i18n.t("birthdayPage.trainer", { price: 199 }),
          i18n.t("birthdayPage.additionalGuest", { price: 79 }),
          i18n.t("birthdayPage.additionalBirthdayBoy", { price: 99 }),
        ],
        rightColumn: [
          i18n.t("birthdayPage.sweetSet", { price: 49 }),
          i18n.t("birthdayPage.saltySet", { price: 49 }),
          i18n.t("birthdayPage.socks", { price: 10 }),
        ],
      },
    },
  };
  return eventsConfig[city];
};
